<i18n src="./resources/locales.json"></i18n>

<template>
  <v-dialog v-model="dialog" persistent max-width="400px">
    <v-card color="surface lighten-1">
      <v-card-title class="header">
        <span v-once>{{ $t('newDashboardTitle') }}</span>
      </v-card-title>

      <v-divider></v-divider>

      <div class="pa-6">
        <v-text-field
          ref="dashboardName"
          v-model="dashboardName"
          autofocus
          required
          class="text-sm-left"
          :label="$t('dashboardName')"
          :disabled="isLoading"
          :rules="dashboardNameRules"
          :counter="64"
          @keydown.enter="confirm"
        />
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">
          <span v-once>{{ $t('buttons.cancel') }}</span>
        </v-btn>
        <v-btn color="primary" depressed @click="confirm">
          <span v-once>{{ $t('buttons.confirm') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const CREATE_CONFIRM_EVENT = 'create-confirm';
const CREATE_CANCEL_EVENT = 'create-cancel';

export default {
  name: 'EcsCreateDashboardDialog',

  props: {
    title: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      dialog: false,
      dashboardName: '',
      isLoading: false,
      dashboardNameRules: [
        value => !!value || this.$t('dashboardRules.required'),
        value => (value || '').length <= 64 || this.$t('dashboardRules.max')
      ]
    };
  },

  methods: {
    async open() {
      this.dialog = true;
      this.dashboardName = '';
      await this.$nextTick();
      this.$refs.dashboardName.resetValidation();
      return new Promise((resolve, reject) => {
        this.$once(CREATE_CONFIRM_EVENT, resolve);
        this.$once(CREATE_CANCEL_EVENT, reject);
      });
    },
    confirm() {
      if (!this.$refs.dashboardName.validate()) {
        this.$refs.dashboardName.focus();
        return false;
      }
      this.dialog = false;
      this.$emit(CREATE_CONFIRM_EVENT, { name: this.dashboardName });
      this.$off(CREATE_CANCEL_EVENT);
      return undefined;
    },
    cancel() {
      this.dialog = false;
      this.$emit(CREATE_CANCEL_EVENT);
      this.$off(CREATE_CONFIRM_EVENT);
    }
  }
};
</script>
<style scoped>
h3 {
  letter-spacing: 0.1em;
}
</style>
